import axios, {
  AxiosError,
  AxiosResponse,
  AxiosInstance,
} from 'axios';
import { getToken } from './tokenUtils';
import { postMessageToParent } from './messageUtils';
import { EMessageType } from '../types';
import { removeToken } from './tokenUtils';


const TOKEN_NOT_FOUND_ERROR = 'Token not found in cookies';


export const setupInterceptors = (
  axiosInstance: AxiosInstance,
) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      if (config.headers?.['x-plum-token'] === 'skip') {
        delete config.headers['x-plum-token'];
        return config;
      }

      const xPlumToken = getToken();
      if (!xPlumToken) {
        // Cancel the request if the xPlumToken is not present
        return Promise.reject(new axios.Cancel(TOKEN_NOT_FOUND_ERROR));
      }

      if (config.headers) {
        config.headers['x-plum-token'] = xPlumToken;
      } else {
        // @ts-ignore
        config.headers = {
          'x-plum-token': xPlumToken,
        };
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    },
  );

  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: AxiosError) => {
      if (
        error.response?.status === 401 ||
        error.message === TOKEN_NOT_FOUND_ERROR
      ) {
        if (typeof window?.NativeBridge?.onNativeLogout === 'function') {
          removeToken();
          window?.NativeBridge?.onNativeLogout();
        } else {
          postMessageToParent(EMessageType.LOG_OUT, {})
        }
      }
      return Promise.reject(error);
    },
  );
};

export default setupInterceptors;